import axios from 'axios';

const headers = {
  Accept: 'application/vindi+json',
  'Content-Type': 'application/json',
};

function csrfHeaders() {
  const token = document.querySelector('[name="csrf-token"]') || { content: 'no-csrf-token' };
  return { ...headers, 'X-CSRF-Token': token.content };
}

async function get(path, queryParams = {}) {
  const params = { app: 'react', ...queryParams };
  return axios.get(path, { headers: csrfHeaders(), params });
}

async function post(path, body) {
  return axios.post(path, body, { headers: csrfHeaders() });
}

async function patch(path, body) {
  return axios.patch(path, body, { headers: csrfHeaders() });
}

export default {
  get, post, patch,
};
